import SendInquiry from "../components/pages/Inquiry/SendInquiry";

const sendInquiry = [
    {
        path: '/onderzoek-versturen',
        component: SendInquiry,
        name: 'send-inquiry',
        beforeEnter:  (to, from, next) => {
            if(sessionStorage.getItem('inquiry-success')) {
                next();
            } else {
                next({ path: '/start-onderzoek' })
            }
        }
    },
]

export default sendInquiry
